export const SAFE_FAKEDOOR_STORE_ID = 'SAFE_FAKEDOOR_STORE_ID';
